import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "uk-container uk-background-default" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { "uk-flex": "" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "uk-background-sections rel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EnterCarrier = _resolveComponent("EnterCarrier")!
  const _component_CarrierTable = _resolveComponent("CarrierTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(_ctx.errorText), 1),
    (_ctx.mainLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("div", { "uk-spinner": "ratio: 3" }, null, -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "uk-button uk-button-large uk-button-primary uk-form-controls",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddNew = !_ctx.showAddNew))
              }, [
                (_ctx.showAddNew)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("span", { "uk-icon": "icon: minus" }, null, -1),
                      _createTextVNode("Close", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("span", { "uk-icon": "icon: plus" }, null, -1),
                      _createTextVNode("New Carrier", -1)
                    ]))]))
              ]),
              _createVNode(_Transition, { name: "slide" }, {
                default: _withCtx(() => [
                  (_ctx.showAddNew)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("button", {
                          class: "uk-close-large close-btn",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddNew = false)),
                          "uk-close": ""
                        }),
                        _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "mt-0 uk-margin-top" }, "Onboard New Carrier", -1)),
                        _createVNode(_component_EnterCarrier, { onAddedCarrier: _ctx.addedCarrier }, null, 8, ["onAddedCarrier"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _cache[7] || (_cache[7] = _createElementVNode("h2", null, "My Carriers", -1)),
              _createVNode(_component_CarrierTable, {
                tableType: "active",
                brokerCarrierAssociations: _ctx.companyCompanyAssociationCarriers
              }, null, 8, ["brokerCarrierAssociations"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "uk-button uk-button-default",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.refreshCarrierData && _ctx.refreshCarrierData(...args)))
              }, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("span", { "uk-icon": "refresh" }, null, -1),
                _createTextVNode(" Refresh All Carrier Data ", -1)
              ]))])
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "uk-divider-icon" }, null, -1))
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1))
        ]))
  ]))
}